import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';

import { apiMutation } from 'app/utils/request/api';

import { ENDPOINTS } from '.';

export function useHotelUnavailable(hotelId: number) {
  return useMutation({
    mutationFn: async () =>
      apiMutation('PATCH', {
        path: ENDPOINTS.setHotelUnavailable,
        params: { hotelId: hotelId.toString() },
      }),
    onSuccess: () => {
      message.success(`No more stock for hotel #${hotelId}!`);
    },
    onError: () => {
      message.error(`Failed to set hotel #${hotelId} unavailable!`);
    },
  });
}
